import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import React, { Component } from 'react';
import { postMessage, sendEmailNotification, fetchMessages } from '../../store/actions/Messages';
import { selectMessages } from '../../store/selectors/Messages';
import { selectAuthenticatedUser } from '../../store/selectors/auth';
import { upload } from '../../helpers/upLoadHelper'
import Loader from '../../components/Loader';
import {  startLoading,stopLoading } from '../../store/actions/loader';
import { PATHS } from '../../common/constants';
import { Messages } from "../../components/Messages/Messages";

class ServiceRequestMessages extends Component {
  constructor(props) {
    super(props);
  }
  onPostMessage= async (chat) =>{
    this.props.startLoading(true)
    let imageUrl = null
    if (chat.image && chat.image.length > 0) {
      imageUrl = await upload(chat.image[0])
    }
    this.props.stopLoading()

    let fileName = imageUrl ? imageUrl.split('.com/') : ''

    // Safely determine sentTo recipient ID
    let sentTo = null;
    const { user, serviceRequest } = this.props;
    const userRole = user.roles[0]?.role?.name;

    if (userRole === 'Property Developer') {
      // Property Developer: send to the other person involved (homeowner or reporter).
      sentTo = serviceRequest.reporter.id === user.id
        ? serviceRequest.suite?.homeOwner?.id
        : serviceRequest.reporter?.id;
    } else {
      // Everyone else (Home Owner, Admin, etc): send to a property manager if available.
      const propertyManagers = serviceRequest.suite?.property?.propertyManagers || [];
      sentTo = propertyManagers.length > 0 ? propertyManagers[0].id : null;
    }

    let data={
        "SentBy":this.props.user.id,
        "SentTo":sentTo ? sentTo : null,
        "ReferenceId":this.props.serviceRequest.id,
        "ReferenceType":"Ticket",
        "Message":chat.message,
        "FileName": fileName[1],
        "FileURL":imageUrl,
        "TicketNumber":this.props.serviceRequest.ticketId.toString(),
        "ActionUrl":"app/service-requests/"+this.props.serviceRequest.id + '/activeTab=1'
     }     
     this.props.postMessage(data) 
  }

  onSendEmailNotification (data) {
    const { serviceRequest, history, url } = this.props;
    let chatId = this.props.ticketId;
    let name = data.sentByName;
    name = name?.replace(/\s/g,'') || ""; 

    const path = {
        pathname: PATHS.VIDEO_CHAT,
        state: { chatId: 'channel' + chatId, sentByName: data.sentByName, sentToName: data.sentToName, url: url, activeTab: 1 }
    }

    let params = {
      "SentBy": data.sentTo,
      "SentTo": data.sentBy,
      "ChannelName": 'channel' + this.props.ticketId,
      "ActionUrl":"app/videoChat/chatId=channel" + chatId + '/' + name,
      "PropertyName": serviceRequest?.suite?.property?.name,
      "SuiteName": serviceRequest.requestType === "CommonArea" ?  serviceRequest?.commonArea?.name : serviceRequest?.suite?.number
    }; 
       
   this.props.sendEmailNotification(params, path, history);
  }
  render() {
    const { messages, inboxLoader } = this.props;
   
    return (
      <>
      {inboxLoader && <Loader center={true}/>}
        <Messages
          serviceRequestId={this.props.serviceRequestId}
          ticketId={this.props.ticketNumber}
          url={this.props.url}
          messages={messages}
          onPostMessage={data => this.onPostMessage(data)}
          onSendEmailNotification={data => this.onSendEmailNotification(data)}
        />
      </>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  user: selectAuthenticatedUser(state),
  messages:selectMessages(state),
  inboxLoader: state.inbox?.inboxListLoader || false
});

const mapDispatchToProps = dispatch => bindActionCreators({
  postMessage,
  sendEmailNotification,
  fetchMessages,
  startLoading,
  stopLoading
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(ServiceRequestMessages);
